export default "__VITE_ASSET__5f142f65__"